<template>
    <div class="survey-choose-student">
        <h4 class="title">{{ $t('rubrics.choose_students') }}</h4>
        <div class="description">
            {{ $t('rubrics.make_a_choice_below_to_indicate_which_students_should_complete_the_chosen_rubrics') }}
        </div>

        <b-form-group
            class="survey-choose-project-select"
            v-if="isProject"
            :label="$t('rubrics.choose_a_project')"
            label-for="survey-choose-project-select">
            <design-2021-apprentice-multiselect-component
                id="survey-choose-project-select"
                v-model="students.projects"
                label="name"
                :multiple-select="true"
                :options="projectOptions"
                :selected-in="students.projects"
                @input="update()"
                :show-labels="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <div class="survey-las-groups">
            <b-form-group
                class="survey-choose-las-main-group"
                :label="$t('rubrics.choose_a_main_group')">
                <design-2021-apprentice-multiselect-component
                    v-model="students.lasMainGroups"
                    label="name"
                    :multiple-select="true"
                    :options="lasMainGroupsIn"
                    :show-labels="false"
                    track-by="id"
                    :allow-empty="true"
                    :disabled="!lasMainGroupsIn.length">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                class="survey-choose-las-group"
                :label="$t('rubrics.choose_a_lesson_group')">
                <design-2021-apprentice-multiselect-component
                    v-model="students.lasGroups"
                    label="name"
                    :multiple-select="true"
                    :options="lasGroupsIn"
                    :show-labels="false"
                    track-by="id"
                    :allow-empty="true"
                    :disabled="!lasGroupsIn.length">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-choose-students-component',
    props: {
        isProject: {
            type: Boolean,
            required: true,
        },

        projectOptionsIn: {
            type: Array,
            required: true,
        },
        value: {},

        lasMainGroupsIn: {
            type: Array,
            required: true,
        },
        lasGroupsIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            students: {
                rubrics: this.value.rubrics,
                lasMainGroups: this.value.lasMainGroups ? this.value.lasMainGroups : [],
                lasGroups: this.value.lasGroups ? this.value.lasGroups : [],
                projects: this.value.projects ? this.value.projects : [],
            },
        };
    },

    methods: {
        updateChanges() {
            this.$emit('input', this.students);
        },
    },

    watch: {
        'students.projects': function () {
            this.updateChanges();
        },

        'students.lasGroups': function () {
            this.updateChanges();
        },

        'students.lasMainGroups': function () {
            this.updateChanges();
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    color: $text-muted-color;
    font-weight: $font-weight-bold;
}
</style>
